import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { DashboardVisual } from "./DashboardVisual";

describe("DashboardVisual", () => {
  it("renders a KPI value and its comparison", () => {
    render(
      <DashboardVisual
        kind="kpi"
        data={{
          value: 125,
          unit: "users",
          comparison: 12,
          comparison_label: "vs last month",
        }}
      />,
    );
    expect(screen.getByText("125 users")).toBeInTheDocument();
    expect(screen.getByText("+12 users vs last month")).toBeInTheDocument();
  });

  it("renders a time series and status distribution", () => {
    const { rerender } = render(
      <DashboardVisual
        kind="time_series"
        data={{
          series: [
            {
              name: "Requests",
              points: [
                { at: "2026-10-01T00:00:00Z", value: 3 },
                { at: "2026-10-02T00:00:00Z", value: 8 },
              ],
            },
          ],
        }}
      />,
    );
    expect(screen.getByText("Requests")).toBeInTheDocument();
    rerender(
      <DashboardVisual
        kind="status_distribution"
        data={{
          items: [
            { status: "Ready", count: 2 },
            { status: "Queued", count: 1 },
          ],
        }}
      />,
    );
    expect(screen.getByText("Ready 2")).toBeInTheDocument();
    expect(screen.getByText("Queued 1")).toBeInTheDocument();
  });

  it("renders breakdown and table rows", () => {
    const { rerender } = render(
      <DashboardVisual
        kind="breakdown"
        data={{ items: [{ label: "Completed", value: 6 }] }}
      />,
    );
    expect(screen.getByText("Completed")).toBeInTheDocument();
    rerender(
      <DashboardVisual
        kind="table"
        data={{
          columns: [{ key: "name", label: "Name" }],
          rows: [{ id: 1, name: "North" }],
        }}
      />,
    );
    expect(screen.getByText("North")).toBeInTheDocument();
  });
});
